import { queryOptions } from '@tanstack/react-query';
import { sortingApi } from './sorting.api';
import type { SortingListParams } from '../types';
import { STALE_TIME } from '@/lib/query/stale-times';

export const sortingQueries = {
  all: () => ({ queryKey: ['sorting'] }),

  list: (params?: SortingListParams) =>
    queryOptions({
      queryKey: ['sorting', 'list', params],
      queryFn: () => sortingApi.getSessions(params),
      placeholderData: (prev) => prev
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: ['sorting', 'detail', id],
      queryFn: () => sortingApi.getSession(id),
      enabled: id > 0
    }),

  metrics: () =>
    queryOptions({
      queryKey: ['sorting', 'metrics'],
      queryFn: () => sortingApi.metrics(),
      staleTime: STALE_TIME.metrics
    })
};
